import { render } from "./ViewNotificationPage.vue?vue&type=template&id=7064c209&ts=true"
import script from "./ViewNotificationPage.vue?vue&type=script&lang=ts"
export * from "./ViewNotificationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__